import { Dispatch } from 'react';

import {
  FetchItemsFilters,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsSort
} from '../../../../../../../types';
import { IndexRequestAction } from '../../reducers/indexRequestReducer';

import { sortItemsAction } from '../sortItemsAction';
import { filterItemsAction } from '../filterItemsAction';
import { paginateItemsAction } from '../paginateItemsAction';
import { limitItemsAction } from '../limitItemsAction';
import isEqual from 'lodash/isEqual';

type UpdatesStateType = {
  filters?: FetchItemsFilters;
  sort?: FetchItemsSort;
  page?: FetchItemsPage;
  limit?: FetchItemsLimit;
};

function dispatchUpdateState(
  dispatch: Dispatch<IndexRequestAction>,
  updates: UpdatesStateType,
  state: UpdatesStateType
) {
  if (
    updates.filters !== undefined &&
    !isEqual(updates.filters, state.filters)
  ) {
    dispatch(filterItemsAction(updates.filters));
  }
  if (updates.sort !== undefined && !isEqual(updates.sort, state.sort)) {
    dispatch(sortItemsAction(updates.sort));
  }
  if (updates.page !== undefined && !isEqual(updates.page, state.page)) {
    dispatch(paginateItemsAction(updates.page));
  }
  if (updates.limit !== undefined && !isEqual(updates.limit, state.limit)) {
    dispatch(limitItemsAction(updates.limit));
  }
}

export default dispatchUpdateState;
